module.exports = __webpack_public_path__ + "img/new-bt.ee401da7.png";